import { RouteMap } from '../../../../../../../../../../header/dispatchHeader/PickupOptimization/Map';
import NoPreview from './NoPreview';
import { withStyles } from '@material-ui/core';

const styles = (_theme) => ({
  container: {
    height: 'calc(100% - 82px)'
  },
  displayNone: {
    display: 'none'
  }
});

const MapPreview = ({
  mapId,
  classes,
  glEventHub,
  selectedRoutes,
  mapConfig,
  shouldShowRoutePreview,
  unassignedPickups = []
}) => {
  const isMapLoading = mapConfig.loading;
  const shouldShowNoPreview = !shouldShowRoutePreview || isMapLoading;
  return (
    <div className={classes.container}>
      {shouldShowNoPreview && <NoPreview />}
      <div className={`${shouldShowNoPreview ? classes.displayNone: ""}`}>
        <RouteMap
          mapId={mapId}
          showDriverLabel
          glEventHub={glEventHub}
          selectedUnassignPickupIds={[]}
          selectedRoutes={selectedRoutes}
          onUnassignPickupSelection={() => {}}
          onUnassignPickupDeselection={() => {}}
          unassignedPickups={unassignedPickups}
        />
      </div>
    </div>
  );
};

export default withStyles(styles)(MapPreview);
